import { Link } from "react-router-dom";

const MBAFloatingApplyButton = () => {
  return (
    <Link
      to="/mba/apply"
      className="fixed z-20 bottom-6 right-6 bg-secondary text-primary rounded-full flex items-center gap-2.5 pl-2.5 pr-4 py-2.5 shadow-course-lockup custom-btn font-poppins"
    >
      <span className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center">
        +
      </span>
      <strong className="text-xs">Apply now</strong>
    </Link>
  );
};

export default MBAFloatingApplyButton;
